import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
// import { Link } from '@bd/bdcore-named-routes';
import { colors } from '../styles';

const styles = css`
background-color: ${colors.white};
padding: 30px 0 75px 0;
position: relative;
@media (min-width: 992px) {
  padding: 120px 0;
}
.Footer_wrapper {
  padding: 0 0 0 0;
}
.Footer_body {
  .Footer_body-content {
    display:flex;
    flex-flow:column nowrap;
    justify-content:center;
    @media (min-width: 992px) {
      flex-flow:row nowrap;
      justify-content:center;
    }
  }
}
.Footer_footer {
  padding:10px 0;
  opacity:.6;
  @media (min-width: 992px) {
    padding:10px 0;
  }
  .Footer_footer-content {
    display:flex;
    flex-flow:row wrap;
    justify-content:center;
  }
}
.Footer_credit {
  font-size: 14px;
  line-height: 1;
  margin: 30px 0;
  padding: 0 0 30px 0;
  border-bottom: 1px solid ${colors.neutral};
  text-align: center;
  @media (min-width: 992px) {
    text-align: center;
    margin: 45px 0 30px;
  }
}
.Footer_credit li:not(:last-child) {
  border-right: 1px solid ${colors.gray};
  margin: 0 10px 10px 0;
  padding: 0 10px 0 0;
  @media (min-width: 992px) {
    margin: 0 10px 0 0;
    padding: 0 10px 0 0;
  }
}
.Footer_address {
  text-align:center;
  @media (min-width: 992px) {
    text-align:center;
  }
}
.Footer_logo {
  width:100%;
  display:flex;
  flex-flow:column nowrap;
  justify-content:center;
  padding:10px 0;
  @media (min-width: 768px) {
    justify-content:flex-start;
    width:33.33333%;
  }
  img {
    max-width: 100%;
    height:auto;
    margin:0 auto;
    @media (min-width: 768px) {
      margin:0;
    }
  }
}
.Footer_socialLinks {
  width:100%;
  display:flex;
  flex-flow:column nowrap;
  justify-content:center;
  padding: 0;
  text-align: center;
  font-weight: 600;
  margin: 0 0 45px 0;
  @media (min-width: 992px) {
    margin: 0;
  }
  ul {
    width:100%;
    margin:0;
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    @media (min-width: 992px) {
      justify-content: flex-start;
    }
    li {
      display: inline-block;
      margin: 10px;
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      @media (min-width: 992px) {
        margin: 0 20px 0 0;
      }
      a img {
        height: 20px;
        width: auto;
        filter: brightness(10%);
      }
    }
  }
}

`;

function Footer({ builder }) {
  return (
    <footer className={styles}>
      <div className="Footer_wrapper">
        <section className="Footer_body">
          <div className="container Footer_body-content">
            <div className="Footer_address">
              <ul className="list-unstyled">
                <li className="mb-3"><img src="/images/logo-elliott-conservancy-black.png" alt={get(builder, 'name')} width="auto" height="80" /></li>
                <li className="sr-only"><strong>{get(builder, 'name')}</strong></li>
                <li>{get(builder, 'address.streetAddress')}</li>
                <li>{get(builder, 'address.addressLocality')}, {get(builder, 'address.addressRegion')} {get(builder, 'address.addressPostalCode')}</li>
                {
                  get(builder, 'telephone') &&
                  <li><a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`}>{get(builder, 'telephone').replace(/\((\d{3})\)\s(\d{3})\s-\s(\d{4})/g, '($1) $2-$3')}</a></li>
                }
              </ul>
            </div>
          </div>
          <div className="container">
            <div className="Footer_credit">
              <ul className="list-unstyled list-inline">
                <li className="list-inline-item">&copy;{(new Date()).getFullYear()} {get(builder, 'name')}</li>
                {/* <li className="list-inline-item">
                <Link name="privacy-policy">Privacy Policy</Link></li>
                <li className="list-inline-item"><Link name="terms">Terms & Conditions</Link></li>
                <li className="list-inline-item"><Link name="accessibility">
                Accessibility Assistance</Link></li> */}
                <li className="list-inline-item">Site By <a href="https://www.builderdesigns.com" target="_blank" rel="noopener noreferrer">Builder Designs</a>.</li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  builder: PropTypes.object.isRequired,
};

export default withData({
  builder: true,
})(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js